import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  List,
  ListItem,
  Typography,
} from '@mui/material';
import { expandableInfoCardStyles } from './styles';

interface ExpandableInfoItem {
  title: string;
  text: string;
}

interface ExpandableInfoCardProps {
  title: string;
  description?: string;
  items?: ExpandableInfoItem[];
}

export const ExpandableInfoCard = ({ title, description, items = [] }: ExpandableInfoCardProps) => (
  <Accordion disableGutters elevation={0} square sx={expandableInfoCardStyles.accordion}>
    <AccordionSummary
      expandIcon={<ExpandMoreIcon sx={expandableInfoCardStyles.expandIcon} />}
      sx={expandableInfoCardStyles.summary}
    >
      <Box sx={expandableInfoCardStyles.summaryContent}>
        <Typography variant="h5" sx={expandableInfoCardStyles.title}>
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" sx={expandableInfoCardStyles.description}>
            {description}
          </Typography>
        )}
      </Box>
    </AccordionSummary>
    <AccordionDetails sx={expandableInfoCardStyles.details}>
      <List disablePadding sx={expandableInfoCardStyles.list}>
        {items.map((item, index) => (
          <ListItem key={index} disableGutters sx={expandableInfoCardStyles.listItem}>
            <Box sx={expandableInfoCardStyles.itemText}>
              <Typography variant="subtitle1" sx={expandableInfoCardStyles.itemTitle}>
                {item.title}
              </Typography>
              <Typography variant="body2" sx={expandableInfoCardStyles.itemDescription}>
                {item.text}
              </Typography>
            </Box>
          </ListItem>
        ))}
      </List>
    </AccordionDetails>
  </Accordion>
);
